{
  "attendance.title": "Attendance",
  "attendance.sections.label": "Attendance views",
  "attendance.sections.month": "Month",
  "attendance.sections.review": "Review",
  "attendance.sections.imports": "Device imports",
  "attendance.sections.settings": "Rules",

  "attendance.month.nav": "Choose the month",
  "attendance.month.previous": "Previous month",
  "attendance.month.next": "Next month",
  "attendance.month.this": "This month",

  "attendance.status.present": "Present",
  "attendance.status.remote": "Work from home",
  "attendance.status.absent": "Absent",
  "attendance.status.missing_punch": "Missing punch",
  "attendance.status.paid_leave": "Paid leave",
  "attendance.status.unpaid_leave": "Unpaid leave",
  "attendance.status.holiday": "Public holiday",
  "attendance.status.off": "Day off",
  "attendance.status.permission": "Permission",
  "attendance.status.external_meeting": "External meeting",
  "attendance.status.not_entered": "Not recorded",
  "attendance.status.upcoming": "Upcoming",
  "attendance.status.not_employed": "Outside employment",
  "attendance.status.not_required": "Attendance not required",

  "attendance.plan.office": "Office",
  "attendance.plan.remote": "Remote",
  "attendance.plan.off": "Off",

  "attendance.cell.worked": "{status} {duration}",
  "attendance.cell.short": "{duration} short",
  "attendance.cell.exempted": "shortfall exempted",
  "attendance.cell.manual": "set by HR",
  "attendance.cell.adjusted": "changed by HR",
  "attendance.deduction.quarter": "quarter-day deduction",
  "attendance.deduction.half": "half-day deduction",
  "attendance.deduction.one": "one-day deduction",
  "attendance.deduction.days": "{count, plural, one {# day deducted} other {# days deducted}}",
  "attendance.review.missing_punch": "needs review: missing punch",
  "attendance.review.location_mismatch": "office check-in from outside the office network",
  "attendance.review.break_overrun": "breaks longer than allowed",
  "attendance.review.long_stretch": "worked longer than allowed in one stretch without recording a break",
  "attendance.review.long_span": "the day ran too long from start to end",
  "attendance.review.long_presence": "stayed past the most hours a day allows",
  "attendance.review.missing_break_end": "a break was left open",

  "attendance.legend.label": "What the grid shows",
  "attendance.legend.short": "Short of the required day",
  "attendance.legend.deduction": "Pay deducted, in days (¼ = a quarter day)",
  "attendance.legend.manual": "Deduction set by HR",
  "attendance.legend.exempted": "Shortfall exempted",
  "attendance.legend.adjusted": "Changed by HR",
  "attendance.legend.marks": "Legend",

  "attendance.grid.label": "Attendance, {month}",
  "attendance.grid.person": "Employee",
  "attendance.grid.department": "Department",
  "attendance.grid.allDepartments": "All departments",
  "attendance.grid.reviewOnly": "Needs review",
  "attendance.grid.selectDay": "Select the short days on {date} ({count})",
  "attendance.grid.selectHint": "Arrow keys move between days and Enter opens one. To exempt several short days at once, press Space or Ctrl-click them, or click a day's header.",
  "attendance.grid.openProfile": "Open their attendance",
  "attendance.grid.loadError": "We could not load the month.",
  "attendance.grid.empty.title": "No one to show",
  "attendance.grid.empty.body": "Nobody with attendance tracked works in this department this month.",
  "attendance.grid.noReview.title": "Nothing waits for review",
  "attendance.grid.noReview.body": "Every day this month is settled. Turn the filter off to see everyone.",

  "attendance.totals.deducted": "{days, plural, one {# day deducted} other {# days deducted}}",
  "attendance.totals.absences": "{count, plural, one {# absence} other {# absences}}",
  "attendance.totals.reviews": "{count, plural, one {# to review} other {# to review}}",
  "attendance.totals.worked": "Worked",
  "attendance.totals.hoursValue": "{hours} h",
  "attendance.totals.deductedLabel": "Deducted",
  "attendance.totals.absencesLabel": "Absences",
  "attendance.totals.reviewsLabel": "To review",
  "attendance.calendar.label": "{name}'s month",

  "attendance.period.status.open": "Month open",
  "attendance.period.status.final": "Month finalized",
  "attendance.period.status.locked": "Month locked",
  "attendance.period.meaning.open": "Days can still change",
  "attendance.period.meaning.final": "Ready for payroll; reopen to change it",
  "attendance.period.meaning.locked": "Locked by payroll for good",
  "attendance.period.blockers": "{count, plural, one {# day or request to settle before finalizing} other {# days or requests to settle before finalizing}}",
  "attendance.period.finalize": "Finalize attendance",
  "attendance.period.reopen": "Reopen month",
  "attendance.period.finalizeTitle": "Finalize {month}?",
  "attendance.period.finalizeBody": "Workdays with nothing recorded become absences, and days can no longer change until the month is reopened.",
  "attendance.period.reopenTitle": "Reopen {month}?",
  "attendance.period.reopenBody": "Days become editable again and are judged anew. Payroll waits until the month is finalized again.",
  "attendance.period.finalized": "{month} is finalized.",
  "attendance.period.reopened": "{month} is open again.",

  "attendance.selection.label": "Selected days",
  "attendance.selection.count": "{count, plural, one {# day selected} other {# days selected}}",
  "attendance.selection.exempt": "Exempt selected",
  "attendance.selection.clear": "Clear",
  "attendance.selection.exemptTitle": "Exempt {count, plural, one {# day} other {# days}} from the shortfall deduction?",
  "attendance.selection.exemptBody": "The hours worked stay recorded; these days' shortfall deduction becomes zero. One reason covers them all.",
  "attendance.selection.exemptConfirm": "Exempt {count, plural, one {# day} other {# days}}",
  "attendance.selection.exempted": "{count, plural, one {# day exempted.} other {# days exempted.}}",
  "attendance.selection.exemptedSkipped": "{count, plural, one {# day exempted} other {# days exempted}}; {total} skipped (closed month or outside employment).",

  "attendance.day.loadError": "We could not load this day.",
  "attendance.day.summary": "The day at a glance",
  "attendance.day.planned": "Planned: {status}",
  "attendance.day.workedOf": "{logged} of {estimate} worked",
  "attendance.day.noDeduction": "No deduction",
  "attendance.day.requests": "Requests for this day",
  "attendance.day.closed.open": "This month is open",
  "attendance.day.closed.final": "This month is finalized",
  "attendance.day.closed.locked": "This month is locked",
  "attendance.day.closedBody.open": "Days can change.",
  "attendance.day.closedBody.final": "Reopen the month to change its days.",
  "attendance.day.closedBody.locked": "Payroll locked this month, so its days can no longer change here.",

  "attendance.sessions.title": "Sessions",
  "attendance.sessions.none": "No sessions recorded for this day.",
  "attendance.sessions.range": "{start} – {end}",
  "attendance.sessions.open": "{start} – now",
  "attendance.sessions.lonePunch": "One punch at {start}",
  "attendance.sessions.unpairedHint": "Only one punch: fix the session or confirm the missing punch.",
  "attendance.sessions.mode.office": "Office",
  "attendance.sessions.mode.remote": "Work from home",
  "attendance.sessions.source.app": "App",
  "attendance.sessions.source.device": "Fingerprint device",
  "attendance.sessions.source.manual": "Added by HR",
  "attendance.sessions.add": "Add session",
  "attendance.sessions.save": "Save session",
  "attendance.sessions.addTitle": "Add a session",
  "attendance.sessions.editTitle": "Correct the session",
  "attendance.sessions.dialogBody": "Record the time really worked. The note is kept in the day's history.",
  "attendance.sessions.from": "From",
  "attendance.sessions.to": "To",
  "attendance.sessions.nextDay": "Ends the next day",
  "attendance.sessions.modeLabel": "Where",
  "attendance.sessions.note": "Why",
  "attendance.sessions.edit": "Correct the session from {start}",
  "attendance.sessions.remove": "Remove the session from {start}",
  "attendance.sessions.removeTitle": "Remove this session?",
  "attendance.sessions.removeBody": "The session from {start} is removed and the day is judged again.",
  "attendance.sessions.removeConfirm": "Remove session",
  "attendance.sessions.added": "Session added.",
  "attendance.sessions.updated": "Session corrected.",
  "attendance.sessions.removed": "Session removed.",
  "attendance.breaks.title": "Breaks",
  "attendance.breaks.none": "No breaks recorded.",
  "attendance.breaks.usedOf": "{used} of the {total} allowed · {left} left",
  "attendance.breaks.usedOver": "{used}, past the {total} allowed",
  "attendance.breaks.autoClosed": "Ended at clock-out",
  "attendance.breaks.kindLabel": "Kind",
  "attendance.breaks.kind.regular": "Break",
  "attendance.breaks.kind.nursing": "Nursing break",
  "attendance.breaks.kindHint.regular": "Counts against the daily break",
  "attendance.breaks.kindHint.nursing": "Counts as work time (Art. 56)",
  "attendance.breaks.source.app": "App",
  "attendance.breaks.source.manual": "Added by HR",
  "attendance.breaks.add": "Add break",
  "attendance.breaks.save": "Save break",
  "attendance.breaks.addTitle": "Add a break",
  "attendance.breaks.editTitle": "Correct the break",
  "attendance.breaks.dialogBody": "Record the break as it really happened. The reason is kept in the day's history.",
  "attendance.breaks.edit": "Correct the break from {start}",
  "attendance.breaks.remove": "Remove the break from {start}",
  "attendance.breaks.removeTitle": "Remove this break?",
  "attendance.breaks.removeBody": "The break from {start} is removed and the day is judged again.",
  "attendance.breaks.removeConfirm": "Remove break",
  "attendance.breaks.added": "Break added.",
  "attendance.breaks.updated": "Break corrected.",
  "attendance.breaks.removed": "Break removed.",
  "attendance.breaks.endBeforeStart": "The break must end after it starts.",
  "attendance.history.title": "History",
  "attendance.history.field.status_override": "Status",
  "attendance.history.field.apply_shortfall_deduction": "Shortfall deduction",
  "attendance.history.field.manual_deduction": "Manual deduction",
  "attendance.history.field.missing_punch_confirmed": "Missing punch confirmed",
  "attendance.history.field.session": "Session",
  "attendance.history.field.break": "Break",
  "attendance.history.none": "—",
  "attendance.history.yes": "Yes",
  "attendance.history.no": "No",
  "attendance.history.to": "to",
  "attendance.history.system": "The system",

  "attendance.tier.title": "How the deduction was reached",
  "attendance.tier.upTo": "Short up to {duration}",
  "attendance.tier.over": "Short over {duration}",
  "attendance.tier.last": "Longest tier",
  "attendance.tier.withinGrace": "Within the {duration} grace",
  "attendance.tier.days": "{count, plural, one {# day} other {# days}}",
  "attendance.tier.hours": "{hours, plural, one {# hour} other {# hours}}",
  "attendance.tier.exempted": "Exempted: no deduction",
  "attendance.tier.replacedByManual": "A deduction set by HR replaces this one.",

  "attendance.exemption.question": "Apply shortfall deduction?",
  "attendance.exemption.yes": "Yes",
  "attendance.exemption.no": "No",
  "attendance.exemption.help": "With No, the hours worked stay recorded and this day's shortfall deduction becomes zero.",
  "attendance.exemption.reason": "Reason for exemption",
  "attendance.exemption.reapplyReason": "Reason for applying it again",
  "attendance.exemption.save": "Save",
  "attendance.exemption.waived": "Shortfall deduction waived for this day.",
  "attendance.exemption.applied": "Shortfall deduction applies again.",

  "attendance.missing.title": "A punch is missing",
  "attendance.missing.body": "This day has only one punch. Correct the session above, or confirm the missing punch so the policy's deduction applies. Until then the month cannot be finalized.",
  "attendance.missing.confirmedTitle": "Missing punch confirmed",
  "attendance.missing.confirmedBody": "The policy's deduction for a missing punch applies to this day.",
  "attendance.missing.confirm": "Apply missing-punch deduction",
  "attendance.missing.confirmTitle": "Confirm the missing punch?",
  "attendance.missing.confirmBody": "The policy's deduction for a missing punch applies to this day.",
  "attendance.missing.confirmBodyCost": "The policy's deduction applies to this day: {amount}.",
  "attendance.missing.confirmed": "Missing punch confirmed.",

  "attendance.adjust.title": "HR adjustments",
  "attendance.override.label": "Status",
  "attendance.override.automatic": "As recorded (automatic)",
  "attendance.override.save": "Save status",
  "attendance.override.saved": "Status saved.",
  "attendance.manual.label": "Manual deduction",
  "attendance.manual.automatic": "Automatic (by the policy)",
  "attendance.manual.kind.none": "No deduction",
  "attendance.manual.kind.one_hour": "1 hour",
  "attendance.manual.kind.two_hours": "2 hours",
  "attendance.manual.kind.quarter_day": "Quarter day",
  "attendance.manual.kind.half_day": "Half day",
  "attendance.manual.kind.one_day": "One day",
  "attendance.manual.kind.two_days": "Two days",
  "attendance.manual.kind.custom_days": "Custom days",
  "attendance.manual.kind.custom_hours": "Custom hours",
  "attendance.manual.days": "Days",
  "attendance.manual.hours": "Hours",
  "attendance.manual.valueInvalid": "Enter a number above 0, up to 31.",
  "attendance.manual.save": "Save deduction",
  "attendance.manual.saved": "Deduction saved.",

  "attendance.review.intro": "Days that need a decision. A missing punch stops the month from being finalized, and an office check-in from outside the office network needs a look. Long breaks and long hours are for information only: nothing is deducted and they never hold the month back.",
  "attendance.review.caption": "Days waiting for review",
  "attendance.review.day": "Day",
  "attendance.review.status": "Status",
  "attendance.review.why": "Why",
  "attendance.review.action": "Decide",
  "attendance.review.open": "Open day",
  "attendance.review.openDay": "Open {name}'s day, {date}",
  "attendance.review.worked": "{duration} worked",
  "attendance.review.loadError": "We could not load the review queue.",
  "attendance.review.empty.title": "Nothing to review",
  "attendance.review.empty.body": "Every day this month is settled.",
  "attendance.review.empty.infoHidden": "Nothing needs a decision. Information-only days are hidden; show them with the option above.",
  "attendance.review.filter.label": "Filter by reason",
  "attendance.review.filter.all": "All",
  "attendance.review.filter.missing_punch": "Missing punch",
  "attendance.review.filter.location_mismatch": "Off-site check-in",
  "attendance.review.filter.missing_break_end": "Open break",
  "attendance.review.filter.break_overrun": "Long break",
  "attendance.review.filter.long_stretch": "No break",
  "attendance.review.filter.long_span": "Long day",
  "attendance.review.filter.long_presence": "Over max hours",
  "attendance.review.showInfo": "Show information-only days ({count})",

  "attendance.imports.title": "Import from the fingerprint device",
  "attendance.imports.steps": "Import steps",
  "attendance.imports.step.upload": "Upload",
  "attendance.imports.step.map": "Map columns",
  "attendance.imports.step.preview": "Preview",
  "attendance.imports.step.done": "Done",
  "attendance.imports.drop": "Drop the device's export here, or choose it",
  "attendance.imports.formats": "CSV or Excel (.xlsx), up to 10 MB",
  "attendance.imports.tooLarge": "This file is larger than 10 MB.",
  "attendance.imports.removeFile": "Choose another file",
  "attendance.imports.upload": "Upload and read",
  "attendance.imports.uploading": "Reading the file…",
  "attendance.imports.back": "Back",
  "attendance.imports.toPreview": "Preview",
  "attendance.imports.map.intro": "{name} has {count, plural, one {# row} other {# rows}}. Tell us which columns say who punched and when.",
  "attendance.imports.map.employee": "Employee column",
  "attendance.imports.map.idKind": "That column holds",
  "attendance.imports.map.idDevice": "The device ID",
  "attendance.imports.map.idCode": "The employee code (404-001)",
  "attendance.imports.map.layout": "The time of each punch is in",
  "attendance.imports.map.layoutTimestamp": "One date-and-time column",
  "attendance.imports.map.layoutSplit": "A date column and a time column",
  "attendance.imports.map.timestamp": "Date and time column",
  "attendance.imports.map.date": "Date column",
  "attendance.imports.map.time": "Time column",
  "attendance.imports.map.dayFirst": "Dates are written day first (13/10/2026)",
  "attendance.imports.map.choose": "Choose a column",
  "attendance.imports.map.column": "Column {number}",
  "attendance.imports.map.required": "Choose a column.",
  "attendance.imports.preview.intro": "The first {count} of {total} rows, as they will be read. The mapped columns are highlighted.",
  "attendance.imports.preview.caption": "Preview of the file",
  "attendance.imports.preview.row": "Row",
  "attendance.imports.preview.flagged": "{count, plural, one {# row looks incomplete} other {# rows look incomplete}}",
  "attendance.imports.preview.flaggedBody": "Rows without an ID or a time are skipped. You can still import; the summary lists every row that could not be read.",
  "attendance.imports.issue.noEmployee": "No ID",
  "attendance.imports.issue.noTime": "No time",
  "attendance.imports.commit": "Import {count, plural, one {# row} other {# rows}}",
  "attendance.imports.committing": "Importing…",
  "attendance.imports.done.title": "{name} is imported",
  "attendance.imports.done.body": "The punches became sessions, and the days are judged again. Punches already imported were skipped, so importing the same file twice is safe.",
  "attendance.imports.done.imported": "Punches imported",
  "attendance.imports.done.skipped": "Skipped",
  "attendance.imports.done.skippedHint": "Already imported, or unreadable",
  "attendance.imports.done.problems": "Rows with problems",
  "attendance.imports.done.problemList": "Rows that could not be imported",
  "attendance.imports.done.row": "Row {number}",
  "attendance.imports.done.another": "Import another file",
  "attendance.imports.done.openMonth": "Open the month",
  "attendance.imports.history.title": "Earlier imports",
  "attendance.imports.history.file": "File",
  "attendance.imports.history.when": "Uploaded",
  "attendance.imports.history.status": "Status",
  "attendance.imports.history.committed": "Imported",
  "attendance.imports.history.previewOnly": "Not imported",
  "attendance.imports.history.loadError": "We could not load the earlier imports.",
  "attendance.imports.history.empty.title": "No imports yet",
  "attendance.imports.history.empty.body": "Files from the fingerprint device appear here once uploaded.",

  "attendance.policy.title": "Attendance policy",
  "attendance.policy.builtIn": "These are the built-in rules, since none were saved yet. Review them and choose Edit rules to make them yours.",
  "attendance.policy.since": "Since {date}",
  "attendance.policy.current": "Latest",
  "attendance.policy.edit": "Change the rules",
  "attendance.policy.editTitle": "New version of the policy",
  "attendance.policy.editIntro": "The new rules apply from the date you choose. Months before it keep the rules they were judged by.",
  "attendance.policy.effectiveFrom": "Applies from",
  "attendance.policy.effectiveHint": "Every month from this date on must be open.",
  "attendance.policy.dateRequired": "Choose the date it applies from.",
  "attendance.policy.basics": "The workday",
  "attendance.policy.dayBasis": "Days in a pay month",
  "attendance.policy.dayBasisHint": "A monthly salary divides into this many days.",
  "attendance.policy.dailyHours": "Standard workday",
  "attendance.policy.dailyHoursHint": "Required each day unless a profile says otherwise; shortfall is measured against it.",
  "attendance.policy.grace": "Grace before a shortfall counts",
  "attendance.policy.graceHint": "A shortfall up to this costs nothing; beyond it, the table below sets the deduction.",
  "attendance.policy.absenceDays": "Deduction for an absence",
  "attendance.policy.absenceDaysHint": "For each day absent without leave or permission. 1 = a full day's pay.",
  "attendance.policy.missingPunchDays": "Deduction for a missing punch",
  "attendance.policy.missingPunchHint": "Applies only once HR confirms the punch is missing.",
  "attendance.policy.overtime": "Overtime",
  "attendance.policy.overtimeDay": "Day overtime rate",
  "attendance.policy.overtimeDayHint": "At least ×1.35 by law.",
  "attendance.policy.overtimeNight": "Night overtime rate",
  "attendance.policy.overtimeNightHint": "At least ×1.70 by law.",
  "attendance.policy.overtimeDayMin": "The day rate cannot be below ×1.35 (or above ×5).",
  "attendance.policy.overtimeNightMin": "The night rate cannot be below ×1.70 (or above ×5).",
  "attendance.policy.restDayPay": "Work on a rest day pays",
  "attendance.policy.restDayPayHint": "What working a rest day pays in total, in days.",
  "attendance.policy.holidayPay": "Work on a public holiday pays",
  "attendance.policy.holidayPayHint": "What working a public holiday pays in total; the law asks for at least double.",
  "attendance.policy.addresses": "Office network addresses",
  "attendance.policy.addressesHint": "One per line, such as 41.33.10.4 or 41.33.10.0/24. Office check-ins from other addresses are flagged for review. Leave empty to not check.",
  "attendance.policy.addressesInvalid": "Use addresses or ranges such as 41.33.10.4 or 41.33.10.0/24 (up to 20).",
  "attendance.policy.noAddresses": "Not checked",
  "attendance.policy.permissions": "Permissions",
  "attendance.policy.permissionMode": "How a permission counts",
  "attendance.policy.permissionModes.credit_minutes": "Count its minutes",
  "attendance.policy.permissionModes.exempt_day": "Count the whole day",
  "attendance.policy.permissionModeHints.credit_minutes": "Only the permission's time is excused.",
  "attendance.policy.permissionModeHints.exempt_day": "The whole day counts as fully worked, even for a one-hour permission.",
  "attendance.policy.permissionCount": "Permissions a month",
  "attendance.policy.permissionsUnit": "a month",
  "attendance.policy.permissionCountHint": "Leave it empty for no limit.",
  "attendance.policy.permissionsValue": "{count} a month",
  "attendance.policy.noLimit": "No limit",
  "attendance.policy.permissionMax": "Longest permission",
  "attendance.policy.permissionMaxHint": "From 15 minutes to 8 hours.",
  "attendance.policy.permissionPaid": "Is permission time paid?",
  "attendance.policy.permissionUnpaidHint": "Unpaid: permission time is deducted from pay.",
  "attendance.policy.paidYes": "Paid",
  "attendance.policy.paidNo": "Unpaid",
  "attendance.policy.permissionCountInvalid": "Enter a whole number from 0 to 31, or leave it blank.",
  "attendance.policy.permissionMaxInvalid": "Enter whole minutes from 15 to 480.",
  "attendance.policy.limits": "Breaks and working hours",
  "attendance.policy.limitsHelp": "Days past these limits go to the review list for a look. They never deduct and don't stop the month from closing.",
  "attendance.policy.breakMinutes": "Daily break",
  "attendance.policy.breakHint": "At least an hour (Art. 118).",
  "attendance.policy.breakInvalid": "Enter 60 to 240 minutes: at least an hour (Art. 118).",
  "attendance.policy.maxStretch": "Longest stretch without a break",
  "attendance.policy.stretchHint": "No more than 5 hours on end (Art. 118).",
  "attendance.policy.stretchInvalid": "Enter 60 to 300 minutes: no more than 5 hours on end (Art. 118).",
  "attendance.policy.maxSpan": "Longest day, start to end",
  "attendance.policy.spanHint": "At most 10 hours from start to end (Art. 119).",
  "attendance.policy.spanInvalid": "Enter 60 to 600 minutes: at most 10 hours from start to end (Art. 119).",
  "attendance.policy.maxPresence": "Longest day with overtime",
  "attendance.policy.presenceHint": "At most 12 hours including overtime (Art. 121).",
  "attendance.policy.presenceInvalid": "Enter 60 to 720 minutes: at most 12 hours with overtime (Art. 121).",
  "attendance.policy.daysUnit": "days",
  "attendance.policy.hoursUnit": "hours",
  "attendance.policy.minutesUnit": "min",
  "attendance.policy.daysValue": "{days, plural, one {# day} other {# days}}",
  "attendance.policy.outOfRange": "This value is outside what the policy allows.",
  "attendance.policy.fixFields": "Some values need a fix before saving.",
  "attendance.policy.reason": "Why the rules change (optional)",
  "attendance.policy.save": "Save new version",
  "attendance.policy.saved": "The new rules are saved.",
  "attendance.policy.history": "Earlier versions",
  "attendance.policy.loadError": "We could not load the attendance rules.",
  "attendance.policy.tiers.title": "Shortfall tiers",
  "attendance.policy.tiers.help": "After the grace, each tier says what a shortfall up to that many minutes costs. The last tier covers anything longer.",
  "attendance.policy.tiers.headUpTo": "If short up to",
  "attendance.policy.tiers.headFactor": "Deduct",
  "attendance.policy.tiers.headUnit": "In",
  "attendance.policy.tiers.longer": "Anything longer",
  "attendance.policy.tiers.upTo": "Tier {number}: up to how many minutes",
  "attendance.policy.tiers.factor": "Tier {number}: amount deducted",
  "attendance.policy.tiers.unit": "Tier {number}: unit",
  "attendance.policy.tiers.unitName.days": "Days",
  "attendance.policy.tiers.unitName.hours": "Hours",
  "attendance.policy.tiers.remove": "Remove tier {number}",
  "attendance.policy.tiers.add": "Add a tier",
  "attendance.policy.tiers.invalid": "Tiers must grow, each above 0 minutes, with an open last tier, and deduct between 0 and 5.",
  "attendance.policy.tiers.grace": "No deduction",
  "attendance.policy.tiers.costDays": "{amount} day",
  "attendance.policy.tiers.costHours": "{amount} hour",

  "attendance.week.defaultTitle": "Default week",
  "attendance.week.defaultBody": "Everyone follows this week unless their own is set.",
  "attendance.week.builtIn": "No week was saved yet, so the built-in week shown here applies.",
  "attendance.week.personTitle": "Weekly plan",
  "attendance.week.ownBody": "Their own week",
  "attendance.week.followsDefault": "Follows the agency's default week",
  "attendance.week.edit": "Change the week",
  "attendance.week.fromHint": "Days from this date on follow the new week.",
  "attendance.week.save": "Save week",
  "attendance.week.saved": "The week is saved.",
  "attendance.week.department": "Department",
  "attendance.week.departmentTitle": "Department week",
  "attendance.week.departmentBody": "This department's own week",

  "attendance.profile.loadError": "We could not load this month.",
  "attendance.profile.untracked.title": "Attendance is not tracked",
  "attendance.profile.untracked.body": "Open an HR record with attendance required to see this person's days.",

  "attendance.mine.caption": "My days this month",
  "attendance.mine.workedColumn": "Worked",
  "attendance.mine.deductionColumn": "Deduction",
  "attendance.mine.loadError": "We could not load your month.",
  "attendance.mine.untracked.title": "Your attendance isn't tracked",
  "attendance.mine.untracked.body": "When HR opens your record with attendance required, your days appear here.",
  "attendance.mine.empty.title": "No days to show",
  "attendance.mine.empty.body": "Your days will appear here once attendance applies to you this month.",

  "attendance.requests.mine": "My requests",
  "attendance.requests.mineBody": "Permissions, external meetings, days from home and punch corrections.",
  "attendance.requests.new": "New request",
  "attendance.requests.newTitle": "New attendance request",
  "attendance.requests.newBody": "Your manager decides first, then HR.",
  "attendance.requests.send": "Send request",
  "attendance.requests.sent": "Request sent.",
  "attendance.requests.loadError": "We could not load your requests.",
  "attendance.requests.empty.title": "No requests yet",
  "attendance.requests.empty.body": "Ask for a permission, an external meeting, a day from home or a punch correction.",
  "attendance.requests.kind.permission": "Permission",
  "attendance.requests.kind.external_meeting": "External meeting",
  "attendance.requests.kind.work_from_home": "Work from home",
  "attendance.requests.kind.punch_correction": "Punch correction",
  "attendance.requests.kindHint.permission": "Arrive late, step out or leave early",
  "attendance.requests.kindHint.external_meeting": "Work away from the office for the day",
  "attendance.requests.kindHint.work_from_home": "Work from home on an office day",
  "attendance.requests.kindHint.punch_correction": "Fix a forgotten or wrong punch",
  "attendance.requests.edge.late_arrival": "Late arrival",
  "attendance.requests.edge.early_leave": "Early leave",
  "attendance.requests.edge.during_hours": "Out during the day",
  "attendance.requests.overQuota": "Over the monthly limit",
  "attendance.requests.exceptionReason": "Exception:",
  "attendance.requests.quota.used": "{used} of {total} used this month",
  "attendance.requests.quota.usedNoLimit": "{used} used this month, no limit",
  "attendance.requests.quota.each": "Up to {duration} each",
  "attendance.requests.quota.unpaid": "Unpaid",
  "attendance.requests.quota.reachedTitle": "You've used this month's permissions",
  "attendance.requests.quota.reachedBody": "You can still send it. It goes to HR as an exception, and only HR can approve it.",
  "attendance.requests.status.pending": "Waiting",
  "attendance.requests.status.approved": "Approved",
  "attendance.requests.status.rejected": "Rejected",
  "attendance.requests.status.cancelled": "Withdrawn",
  "attendance.requests.form.kind": "What do you need?",
  "attendance.requests.form.date": "Day",
  "attendance.requests.form.edge": "When",
  "attendance.requests.form.start": "Real check-in",
  "attendance.requests.form.end": "Real check-out",
  "attendance.requests.form.reason": "Reason",
  "attendance.requests.form.dateRequired": "Choose the day.",
  "attendance.requests.form.timeInvalid": "Enter a time such as 09:05.",
  "attendance.requests.form.endBeforeStart": "The check-out must come after the check-in.",
  "attendance.requests.form.from": "From",
  "attendance.requests.form.to": "To",
  "attendance.requests.form.length": "{duration} in all",
  "attendance.requests.form.permissionTooLong": "A permission can be up to {duration}.",
  "attendance.requests.form.permissionEndBeforeStart": "The end must come after the start.",
  "attendance.requests.showFlow": "Approval steps",
  "attendance.requests.cancel": "Withdraw",
  "attendance.requests.cancelTitle": "Withdraw this request?",
  "attendance.requests.cancelBody": "Nobody will need to decide on it any more.",
  "attendance.requests.cancelConfirm": "Withdraw request",
  "attendance.requests.keep": "Keep it",
  "attendance.requests.cancelled": "Request withdrawn.",

  "attendance.clock.label": "Attendance clock",
  "attendance.clock.title": "Attendance",
  "attendance.clock.on": "Clocked in",
  "attendance.clock.sinceShort": "{mode} · since {start}",
  "attendance.clock.in": "Clock in",
  "attendance.clock.out": "Clock out",
  "attendance.clock.inShort": "In",
  "attendance.clock.outShort": "Out",
  "attendance.clock.plan.office": "Office day",
  "attendance.clock.plan.remote": "Remote day",
  "attendance.clock.plan.off": "Day off",
  "attendance.clock.since": "Clocked in since {start}",
  "attendance.clock.inToast": "Clocked in at {start}.",
  "attendance.clock.outToast": "Clocked out at {start}.",
  "attendance.clock.mismatch": "Clocked in as office from outside the office network: HR will review it.",
  "attendance.clock.mismatchToast": "Clocked in. You are outside the office network, so HR will review this office check-in.",
  "attendance.break.start": "Start break",
  "attendance.break.end": "End break",
  "attendance.break.startShort": "Break",
  "attendance.break.endShort": "Back",
  "attendance.break.onBreak": "On a break",
  "attendance.break.since": "On a break since {start}",
  "attendance.break.today": "Today's break",
  "attendance.break.used": "{used} of {total} min used",
  "attendance.break.left": "{left} min of break left",
  "attendance.break.over": "{used} min, past {total}",
  "attendance.break.overHint": "Past today's break time. HR will see it; nothing is deducted.",
  "attendance.break.startToast": "Break started at {start}.",
  "attendance.break.endToast": "Welcome back. This break took {took} min; {used} of {total} min used today, {left} min left.",
  "attendance.break.overToast": "Welcome back. This break took {took} min and today's breaks reached {used} min, past {total}: HR will see it, nothing is deducted.",
  "attendance.break.resumeToast": "Break started at {start}. You already used {used} min today, {left} min left.",
  "attendance.break.totalToday": "All of today's breaks",
  "attendance.break.thisOne": "This break started at {start}",
  "attendance.clock.workedToday": "Worked today, breaks not counted",
  "attendance.presence.title": "Right now",
  "attendance.presence.refresh": "Updates every minute",
  "attendance.presence.filter": "Show people by state",
  "attendance.presence.list": "Who is in right now",
  "attendance.presence.state.working": "Working",
  "attendance.presence.state.on_break": "On a break",
  "attendance.presence.state.on_leave": "On leave",
  "attendance.presence.state.off_duty": "Off",
  "attendance.presence.since": "Since {start}",
  "attendance.presence.onBreakSince": "On a break since {start}",
  "attendance.presence.breaks": "Breaks {used} of {total} · {left} left",
  "attendance.presence.breaksOver": "Breaks {used}, past the {total} allowed",
  "attendance.presence.loadError": "We could not load who is in right now.",
  "attendance.presence.noneInState": "Nobody in this state right now.",
  "attendance.presence.nobodyIn": "Everyone is off duty right now.",

  "attendance.errors.periodLocked": "This month is locked; its days can no longer change.",
  "attendance.errors.periodFinal": "This month is finalized. Reopen it to change its days.",
  "attendance.errors.periodBlockers": "Days still wait for review, or requests for a decision, so the month cannot be finalized yet.",
  "attendance.errors.alreadyClockedIn": "You are already clocked in.",
  "attendance.errors.notClockedIn": "You are not clocked in.",
  "attendance.errors.sessionNotFound": "That session no longer exists.",
  "attendance.errors.sessionOverlap": "This session overlaps another one on the same day.",
  "attendance.errors.sessionInvalid": "Check the times: the end must come after the start, within a day, and not in the future.",
  "attendance.errors.noRecord": "There is no HR record with attendance for this person.",
  "attendance.errors.reason": "Write the reason for the change.",
  "attendance.errors.policyInvalid": "These rules do not hold together. Check the tiers and limits.",
  "attendance.errors.importNotFound": "That import no longer exists. Upload the file again.",
  "attendance.errors.importCommitted": "This file was already imported.",
  "attendance.errors.importUnreadable": "We could not read this file. Export it as CSV or .xlsx and try again.",
  "attendance.errors.requestNotFound": "That request no longer exists.",
  "attendance.errors.requestExists": "You already asked for this on that day.",
  "attendance.errors.requestClosed": "This request was already decided or withdrawn.",
  "attendance.errors.permissionTooLong": "This permission is longer than the policy allows.",
  "attendance.errors.permissionOverQuota": "This permission is over the monthly limit, so only HR can approve it, with the reason in the comment.",
  "attendance.errors.breakAlreadyStarted": "You are already on a break.",
  "attendance.errors.breakNotStarted": "You are not on a break.",
  "attendance.errors.breakInvalid": "Check the times: a break ends after it starts, inside time worked that day.",
  "attendance.errors.breakNotFound": "That break no longer exists.",
  "attendance.errors.weeklyRestRequired": "A week needs at least one rest day (Art. 120).",
  "attendance.errors.validation": "Some details were not accepted. Check them and try again."
}
